import "@mui/material";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useModalContext } from "../../modals";
import { ResetPasswordModal } from "../resetPassword";

export const AuthForgotPasswordButton = () => {
  const theme = useSelector((state: RootState) => state.theme);
  const { showModal } = useModalContext();

  return (
    <Button
      sx={{
        textTransform: "none",
        color: theme.componentColors.surface.surfaceFull,
      }}
      onClick={() => {
        showModal(<ResetPasswordModal />);
      }}
      variant="text"
      className="rounded-2xl px-[16px] text-[14px] font-light w-44 self-end"
    >
      Forgot Password?
    </Button>
  );
};
